import React from 'react'
import PropTypes from 'prop-types'
import {graphql} from 'gatsby'
import Layout from '../components/Layout'
import Mask from '../img/mask.svg';
import {
    HomeContainer,
    Image,
    Title,
    CtoRow
} from '../components/home/StyledHomePage';
import {SecondaryButton} from '../components/button/CloseButton';

const IndexPageTemplate = ({
                                      title,
                                      img
                                  }) => (
    <HomeContainer>
        <div>
            <Title>{title}</Title>
            <CtoRow>
                <SecondaryButton to={"/product"}>exposition</SecondaryButton>
                <SecondaryButton to={"/contact"}>Contact us</SecondaryButton>
            </CtoRow>
        </div>
        <Image mask={Mask} src={img}/>
    </HomeContainer>
);

const IndexPage = ({data}) => {
    const {frontmatter} = data.markdownRemark;

    return (
        <Layout>
            <IndexPageTemplate
                title={frontmatter.title}
                img={frontmatter.image.childImageSharp.original.src}
            />
        </Layout>
    )
};

IndexPage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.shape({
            frontmatter: PropTypes.object,
        }),
    }),
};

export default IndexPage

export const pageQuery = graphql`
    query IndexPageTemplate {
        markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
            frontmatter {
                title
                image {
                    childImageSharp {
                        original {
                            src
                        }
                    }
                }
            }
        }
    }
`;
